import ProgramAdminDataTable from "./ProgramAdminDataTable.vue";
import ProgramAdminExpansion from "./ProgramAdminExpansion.vue";

export default ProgramAdminDataTable;

export { ProgramAdminDataTable, ProgramAdminExpansion };
